"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// tslint:disable:max-file-line-count
var authentication_widget_1 = require("@cian/authentication-widget");
var React = require("react");
var tracking = require("./tracking");
var ESuccesEventType;
(function (ESuccesEventType) {
    ESuccesEventType["authentication"] = "authentication";
    ESuccesEventType["socAuthentication"] = "social authentication";
    ESuccesEventType["registration"] = "registation";
    ESuccesEventType["email"] = "email sent closed";
})(ESuccesEventType = exports.ESuccesEventType || (exports.ESuccesEventType = {}));
var Authentication = /** @class */ (function (_super) {
    tslib_1.__extends(Authentication, _super);
    function Authentication() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.twoFactorType = undefined;
        _this.isEmailChecked = false;
        _this.handleEmailChecked = function () {
            _this.isEmailChecked = true;
        };
        _this.handleFlowChanged = function (_a) {
            var flow = _a.flow;
            if (flow) {
                tracking.trackFlowChange(flow, _this.isEmailChecked ? tracking.EFlowChangeType.Email : tracking.EFlowChangeType.Id);
            }
            else {
                _this.isEmailChecked = false;
            }
        };
        _this.handleViewChanged = function (_a) {
            var prevView = _a.prevView, view = _a.view;
            if (prevView === authentication_widget_1.EActiveView.AuthenticationRegistration && view === authentication_widget_1.EActiveView.Restore) {
                tracking.trackForgotPasswordClick();
            }
            if (prevView === authentication_widget_1.EActiveView.SocialMerge && view === authentication_widget_1.EActiveView.Restore) {
                tracking.trackForgotPasswordClickMerge();
            }
            if ((prevView === authentication_widget_1.EActiveView.TwoFactor || prevView === authentication_widget_1.EActiveView.TwoFactorWithEmail) &&
                view === authentication_widget_1.EActiveView.AuthenticationRegistration) {
                tracking.trackTwoFactorClose(_this.twoFactorType);
            }
            if (prevView !== authentication_widget_1.EActiveView.ConfirmPhone && view === authentication_widget_1.EActiveView.ConfirmPhone) {
                tracking.trackConfirmPhoneShown();
            }
            if ([authentication_widget_1.EActiveView.AuthenticationRegistration, authentication_widget_1.EActiveView.ConfirmPhone].includes(prevView)
                && view === authentication_widget_1.EActiveView.EmailSent) {
                tracking.trackRegistrationDonePopup();
            }
            if (view === authentication_widget_1.EActiveView.SocialCreate) {
                tracking.trackSocialCreateShow();
            }
            if (prevView === authentication_widget_1.EActiveView.SocialCreate && view === authentication_widget_1.EActiveView.EmailSent) {
                tracking.trackSocialCreateCreateClick();
            }
        };
        _this.handleSocialButtonClick = function (_a) {
            var type = _a.type;
            tracking.trackSocialButtonClick(type);
        };
        _this.handleSocialAuthenticateSucceed = function (_a) {
            var type = _a.type, isNewUser = _a.isNewUser;
            if (isNewUser) {
                tracking.trackRegistrationSuccess(type);
            }
            else {
                tracking.trackAuthenticateSuccess(type);
                _this.authenticationSucceed();
            }
        };
        _this.handleSocialAuthenticateEmailTaken = function () {
            tracking.trackSocialAuthenticateEmailTaken();
        };
        _this.handleSocialMergeMergeClick = function () {
            tracking.trackSocialMergeMergeClick();
        };
        _this.handleSocialMergeSucceed = function () {
            tracking.trackSocialMergeSucceed();
        };
        _this.handleTwoFactorRequired = function (_a) {
            var type = _a.type;
            _this.twoFactorType = type;
            tracking.trackTwoFactorPopupOpen(type);
        };
        _this.handleTwoFactorAttemptsExhausted = function () {
            tracking.trackTwoFactorAttemptsExhaustedPopupOpen(_this.twoFactorType);
        };
        _this.handleTwoFactorInvalid = function () {
            tracking.trackTwoFactorInvalid(_this.twoFactorType);
        };
        _this.handleTwoFactorWhatForClick = function () {
            tracking.trackTwoFactorWhatForClick(_this.twoFactorType);
        };
        _this.handleTwoFactorContinueClick = function () {
            tracking.trackTwoFactorContinueClick(_this.twoFactorType);
        };
        _this.handleTwoFactorResendClick = function () {
            tracking.trackTwoFactorResendClick(_this.twoFactorType);
        };
        _this.handleTwoFactorCannotConfirmClick = function () {
            tracking.trackTwoFactorCannotConfirmClick(_this.twoFactorType);
        };
        _this.handleTwoFactorAttemptsExhaustedSupportClick = function () {
            tracking.trackTwoFactorAttemptsExhaustedSupportClick(_this.twoFactorType);
        };
        _this.handleAuthenticateSucceed = function () {
            var getType = function () {
                if (_this.twoFactorType === authentication_widget_1.ETwoFactorType.Sms) {
                    return 'phone_code';
                }
                if (_this.twoFactorType === authentication_widget_1.ETwoFactorType.Email) {
                    return 'email_code';
                }
                return 'email';
            };
            tracking.trackAuthenticateSuccess(getType());
            _this.authenticationSucceed();
        };
        _this.handleRestoreSucceed = function () {
            tracking.trackForgotPasswordSubmitSuccess();
        };
        _this.handleRegisterSucceed = function (_a) {
            var wantsSubscription = _a.wantsSubscription;
            tracking.trackRegistrationSuccess('email');
            if (wantsSubscription) {
                tracking.trackWantsSubscription();
            }
        };
        _this.handleEmailSentClosed = function (_a) {
            var type = _a.type;
            if (type === authentication_widget_1.ESentEmailType.Registration) {
                tracking.trackRegistrationDonePopupClose();
                _this.authenticationSucceed();
            }
        };
        _this.handleConfirmPhoneConfirmClick = function () {
            tracking.trackConfirmPhoneConfirmClick();
        };
        _this.handleConfirmPhoneResendClick = function () {
            tracking.trackConfirmPhoneResendClick();
        };
        _this.handleConfirmPhoneSucceed = function () {
            tracking.trackConfirmPhoneSucceed();
        };
        _this.authenticationSucceed = function () {
            getUserDataOnSuccess(ESuccesEventType.authentication);
        };
        return _this;
    }
    Authentication.prototype.componentDidMount = function () {
        var context = this.props.context;
        context.on(authentication_widget_1.EEventType.EmailChecked, this.handleEmailChecked);
        context.on(authentication_widget_1.EEventType.FlowChanged, this.handleFlowChanged);
        context.on(authentication_widget_1.EEventType.ViewChanged, this.handleViewChanged);
        context.on(authentication_widget_1.EEventType.AuthenticateSucceed, this.handleAuthenticateSucceed);
        context.on(authentication_widget_1.EEventType.RestoreSucceed, this.handleRestoreSucceed);
        context.on(authentication_widget_1.EEventType.RegisterSucceed, this.handleRegisterSucceed);
        context.on(authentication_widget_1.EEventType.EmailSentClosed, this.handleEmailSentClosed);
        /**
         * Социальная авторизация
         */
        context.on(authentication_widget_1.EEventType.SocialButtonClick, this.handleSocialButtonClick);
        context.on(authentication_widget_1.EEventType.SocialAuthenticateSucceed, this.handleSocialAuthenticateSucceed);
        context.on(authentication_widget_1.EEventType.SocialAuthenticateEmailTaken, this.handleSocialAuthenticateEmailTaken);
        context.on(authentication_widget_1.EEventType.SocialMergeMergeClick, this.handleSocialMergeMergeClick);
        context.on(authentication_widget_1.EEventType.SocialMergeSucceed, this.handleSocialMergeSucceed);
        /**
         * Двухфакторная авторизация
         */
        context.on(authentication_widget_1.EEventType.TwoFactorRequired, this.handleTwoFactorRequired);
        context.on(authentication_widget_1.EEventType.TwoFactorInvalid, this.handleTwoFactorInvalid);
        context.on(authentication_widget_1.EEventType.TwoFactorWhatForClick, this.handleTwoFactorWhatForClick);
        context.on(authentication_widget_1.EEventType.TwoFactorResendClick, this.handleTwoFactorResendClick);
        context.on(authentication_widget_1.EEventType.TwoFactorContinueClick, this.handleTwoFactorContinueClick);
        context.on(authentication_widget_1.EEventType.TwoFactorCannotConfirmClick, this.handleTwoFactorCannotConfirmClick);
        context.on(authentication_widget_1.EEventType.TwoFactorAttemptsExhausted, this.handleTwoFactorAttemptsExhausted);
        context.on(authentication_widget_1.EEventType.TwoFactorAttemptsExhaustedSupportClick, this.handleTwoFactorAttemptsExhaustedSupportClick);
        /**
         * Регистрация
         */
        context.on(authentication_widget_1.EEventType.ConfirmPhoneConfirmClick, this.handleConfirmPhoneConfirmClick);
        context.on(authentication_widget_1.EEventType.ConfirmPhoneResendClick, this.handleConfirmPhoneResendClick);
        context.on(authentication_widget_1.EEventType.ConfirmPhoneSucceed, this.handleConfirmPhoneSucceed);
    };
    Authentication.prototype.componentWillUnmount = function () {
        var context = this.props.context;
        context.off(authentication_widget_1.EEventType.EmailChecked, this.handleEmailChecked);
        context.off(authentication_widget_1.EEventType.FlowChanged, this.handleFlowChanged);
        context.off(authentication_widget_1.EEventType.ViewChanged, this.handleViewChanged);
        context.off(authentication_widget_1.EEventType.AuthenticateSucceed, this.handleAuthenticateSucceed);
        context.off(authentication_widget_1.EEventType.RestoreSucceed, this.handleRestoreSucceed);
        context.off(authentication_widget_1.EEventType.RegisterSucceed, this.handleRegisterSucceed);
        context.off(authentication_widget_1.EEventType.EmailSentClosed, this.handleEmailSentClosed);
        /**
         * Социальная авторизация
         */
        context.off(authentication_widget_1.EEventType.SocialButtonClick, this.handleSocialButtonClick);
        context.off(authentication_widget_1.EEventType.SocialAuthenticateSucceed, this.handleSocialAuthenticateSucceed);
        context.off(authentication_widget_1.EEventType.SocialAuthenticateEmailTaken, this.handleSocialAuthenticateEmailTaken);
        context.off(authentication_widget_1.EEventType.SocialMergeMergeClick, this.handleSocialMergeMergeClick);
        context.off(authentication_widget_1.EEventType.SocialMergeSucceed, this.handleSocialMergeSucceed);
        /**
         * Двухфакторная авторизация
         */
        context.off(authentication_widget_1.EEventType.TwoFactorRequired, this.handleTwoFactorRequired);
        context.off(authentication_widget_1.EEventType.TwoFactorInvalid, this.handleTwoFactorInvalid);
        context.off(authentication_widget_1.EEventType.TwoFactorWhatForClick, this.handleTwoFactorWhatForClick);
        context.off(authentication_widget_1.EEventType.TwoFactorContinueClick, this.handleTwoFactorContinueClick);
        context.off(authentication_widget_1.EEventType.TwoFactorResendClick, this.handleTwoFactorResendClick);
        context.off(authentication_widget_1.EEventType.TwoFactorCannotConfirmClick, this.handleTwoFactorCannotConfirmClick);
        context.off(authentication_widget_1.EEventType.TwoFactorAttemptsExhausted, this.handleTwoFactorAttemptsExhausted);
        context.off(authentication_widget_1.EEventType.TwoFactorAttemptsExhaustedSupportClick, this.handleTwoFactorAttemptsExhaustedSupportClick);
        /**
         * Регистрация
         */
        context.off(authentication_widget_1.EEventType.ConfirmPhoneConfirmClick, this.handleConfirmPhoneConfirmClick);
        context.off(authentication_widget_1.EEventType.ConfirmPhoneResendClick, this.handleConfirmPhoneResendClick);
        context.off(authentication_widget_1.EEventType.ConfirmPhoneSucceed, this.handleConfirmPhoneSucceed);
    };
    Authentication.prototype.render = function () {
        var context = this.props.context;
        return (React.createElement(authentication_widget_1.Provider, { context: context },
            React.createElement("div", null,
                React.createElement(authentication_widget_1.Authentication, { stepFlow: true }))));
    };
    return Authentication;
}(React.Component));
exports.Authentication = Authentication;
function getUserDataOnSuccess(type, shouldClosePopup) {
    if (shouldClosePopup === void 0) { shouldClosePopup = true; }
    //  tslint:disable-next-line:no-any
    return window.__onAuthOrRegisterSuccess()
        .then(function () {
        if (shouldClosePopup) {
            // tslint:disable-next-line:no-any
            window.__authenticationClose();
        }
    })
        .catch(function () {
        throw new Error("Failed to get User Data after " + type);
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/shared/Authentication/Authentication.tsx
// module id = 239
// module chunks = 2